
import { Outlet } from "react-router-dom";

const Layout = () => {
  return (
    <div id="containerCustom">
      <Outlet />
    </div >
  )
}

export default Layout
